
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quotespot/[category]",
      function () {
        return require("private-next-pages/quotespot/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quotespot/[category]"])
      });
    }
  